import React from "react";

export function SkeletonBlock({ className = "" }) {
  return <div className={`skeleton-shimmer rounded-lg ${className}`} />;
}

export function TableRowsSkeleton({ rows = 5, cols = 5 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r} className="border-b border-[#272A30]/50">
          {Array.from({ length: cols }).map((__, c) => (
            <td key={c} className="px-4 py-3">
              <SkeletonBlock className="h-4 w-full max-w-[160px]" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

export function CardSkeleton({ className = "" }) {
  return (
    <div className={`rounded-xl border border-[#272A30] bg-[#111318] p-5 ${className}`}>
      <SkeletonBlock className="h-3 w-24 mb-4" />
      <SkeletonBlock className="h-7 w-32" />
    </div>
  );
}
